module.exports = __webpack_public_path__ + "static/img/JGArchitecture_审核_image@2x.5dfc36b4.png";